import { FC, ReactElement } from 'react';
import { ColorBadge, ColorBadgeProps } from './ColorBadge';
import useTheme from '@base/useTheme';

export type ColorIconBadgeProps = Omit<ColorBadgeProps, 'color'> & {
    icon: ReactElement;
};

export const ColorIconBadge: FC<ColorIconBadgeProps> = (props: ColorIconBadgeProps) => {
    const { icon, ...rest } = props;
    const theme = useTheme();

    return (
        <ColorBadge {...rest} color={'#ffffff'} round>
            <div style={{ margin: '-2px', fill: theme.colors.neutral.w900 }}>{icon}</div>
        </ColorBadge>
    );
};
